import * as React from "react";
import type { SVGProps } from "react";
const SvgLiftChairFront = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#lift-chair-front_svg__a)">
      <path d="M12 10.14c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1s1 .45 1 1v4.14c0 .55-.45 1-1 1" />
      <path d="M8 7c-.4 0-.79-.25-.94-.65-.19-.52.07-1.09.58-1.29l8.01-3c.52-.19 1.09.07 1.29.59.19.52-.07 1.09-.58 1.29l-8.01 3C8.23 6.98 8.12 7 8 7M18.5 19c-.55 0-1-.45-1-1v-2H6.51v1.83c0 .55-.45 1-1.01 1s-1-.45-1-1v-1.85c0-1.09.84-1.98 1.87-1.98h11.26c1.03 0 1.87.89 1.87 1.98V18c0 .55-.45 1-1 1" />
      <path d="M18.07 22H5.94C4.87 22 4 21.13 4 20.06V18c0-.55.45-1 1-1h14c.55 0 1 .45 1 1v2.06c0 1.07-.87 1.94-1.94 1.94zM6.01 19v1.06L18.07 20l-.03-1H6z" />
      <path d="M19.53 19c-.55 0-1-.45-1-1s.45-1 1-1c.17 0 .28-.1.34-.18.11-.14.15-.33.11-.52l-1.07-4.55c-.1-.44-.46-.75-.87-.75H5.95c-.41 0-.76.31-.87.75L4.01 16.3c-.04.19 0 .38.11.52.06.08.18.18.34.18.55 0 1 .45 1 1s-.45 1-1 1c-.75 0-1.44-.34-1.91-.94-.5-.63-.67-1.44-.49-2.22l1.07-4.55C3.45 9.94 4.6 9 5.94 9h12.09c1.34 0 2.5.94 2.81 2.29l1.07 4.55c.18.79 0 1.6-.49 2.22-.47.59-1.17.94-1.91.94z" />
    </g>
    <defs>
      <clipPath id="lift-chair-front_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLiftChairFront;
